// Presentation only: match complete, known server messages. Never infer whether
// data was saved from an error code, and preserve unrecognized messages verbatim.
const API_ERROR_COPY = new Map<string, string>([
  // Account and request handling.
  ["Account ID 或密码不正确", "账户编号或密码不正确"],
  ["请输入 Account ID 和当前密码", "请输入账户编号和当前密码"],
  ["Account ID 与当前账户不一致", "填写的账户编号与当前登录账户不一致"],
  ["认证版本已更新，请使用恢复密钥重设密码", "登录验证方式已更新，请使用恢复密钥重设密码"],
  ["请求必须使用 application/json", "请求格式无法识别，请刷新页面后重试"],
  ["请求 JSON 无法解析", "无法读取这次请求的内容，请刷新页面后重试"],
  ["请求包含未定义字段", "请求中有无法识别的内容，请刷新页面后重试"],
  ["服务器暂时无法完成请求", "这次请求未能完成，请稍后重试"],
  // Matching Pool naming (server messages keep their frozen wording; the participant sees the product term).
  ["匹配池功能暂未开放", "Matching Pool 暂未开放"],
  ["必须确认当前年龄段和进入匹配池", "请确认当前年龄段，并确认加入 Matching Pool"],
  ["请确认加入匹配池说明", "请确认 Matching Pool 的参与说明"],
  ["首次发布只能通过进入匹配池事务完成", "首次发布资料需要在加入 Matching Pool 时一并完成"],
  ["没有这个 API 路由", "找不到这项服务，请刷新页面后重试"],
  ["没有这个 Operator API 路由", "找不到这项管理服务，请刷新页面后重试"],
  ["草稿 revision 不正确", "草稿版本信息无效，请刷新后重试"],
  ["所在地版本必须是正整数或 null", "所在地的版本信息无效，请刷新后重试"],
  ["匹配偏好版本必须是正整数", "匹配偏好的版本信息无效，请刷新后重试"],
  ["版本号必须是正整数或 null", "版本信息无效，请刷新后重试"],
  ["版本号必须是正整数", "版本信息无效，请刷新后重试"],
  ["缺少有效的 Idempotency-Key", "无法识别这次操作，请刷新后重试"],
  ["该 Idempotency-Key 已用于不同请求", "同一次操作提交了不同内容，请刷新状态后再操作"],
  ["已完成操作缺少可重放响应", "暂时无法读取上次操作的结果，请先刷新状态，避免重复操作"],
  ["activeOutcome 不属于支持的选择", "请选择继续匹配还是保存并暂停"],
  ["activeOutcome 只能是 save_and_pause", "这项设置需要通过“保存并暂停”提交"],
  ["refreshCandidates 必须是布尔值", "刷新人选的请求格式有误，请刷新页面后重试"],
  ["locale 必须是字符串", "语言设置格式有误，请刷新页面后重试"],

  // Profile fields and participation eligibility.
  ["displayName 必须是字符串或 null", "显示名称的格式有误，请重新填写"],
  ["customGenderDisplayLabel 必须是字符串或 null", "性别称呼的格式有误，请重新填写"],
  ["pronouns 必须是字符串或 null", "代词的格式有误，请重新填写"],
  ["shortIntroduction 必须是字符串或 null", "简短介绍的格式有误，请重新填写"],
  ["beforeYouMeetMeText 必须是字符串或 null", "见面前想让对方知道的内容格式有误，请重新填写"],
  ["值不属于冻结规格", "这项内容不在当前允许的范围内，请重新选择或填写"],
  ["年龄段不属于冻结选项", "请选择目前提供的年龄段"],
  ["必须选择冻结年龄段并明确确认", "请选择年龄段，并确认是否准确"],
  ["请先填写候选人可见资料", "请先填写要展示给对方的资料"],
  ["候选人可见资料尚未完整", "展示资料还没有填完整，请补全后继续"],
  ["候选人可见资料包含不能保存的内容", "展示资料中有不符合要求的内容，请检查下方提示"],
  ["请先预览确切候选人可见资料", "请先预览对方会看到的资料"],
  ["必须重新预览确切候选资料", "请重新预览对方会看到的资料"],
  ["请重新预览确切的候选人可见资料", "请重新预览对方会看到的资料"],
  ["候选人可见资料已变化，请重新预览", "展示资料已更新，请重新预览"],
  ["候选人可见资料已变化", "展示资料已更新，请刷新后再继续"],
  ["候选人可见资料已不存在", "这份展示资料已不存在"],
  ["请选择性别资格路由类别", "请选择用于匹配的性别分类"],
  ["请选择愿意认识的性别类别", "请选择愿意认识的性别"],
  ["请选择可接受年龄段", "请选择愿意认识的年龄段"],
  ["profileSource 必须是 draft 或 published", "请选择要预览的草稿或已发布资料"],
  ["confirmAgeBand 必须是布尔值", "年龄段确认格式有误，请重新确认"],
  ["已永久结束匹配参与，无法修改候选人可见资料", "已永久结束匹配，无法再修改展示资料"],
  ["资料草稿版本已变化", "资料草稿已更新，请刷新后再修改"],
  ["候选资料版本已变化", "展示资料已更新，请刷新后再继续"],
  ["已发布候选资料版本已变化", "已发布的资料已更新，请刷新后再继续"],
  ["匹配偏好版本已变化", "匹配偏好已更新，请刷新后再继续"],
  ["匹配参与版本已变化", "参与状态已更新，请刷新后再继续"],
  ["草稿基于的已发布资料版本已变化", "已发布的资料已更新，这份草稿仍基于旧资料，请刷新后核对"],
  ["资料草稿基于的已发布版本已变化", "已发布的资料已更新，这份草稿仍基于旧资料，请刷新后核对"],
  ["资格状态已变化，请重试确认", "参与条件已变化，请刷新后重新确认"],
  ["不接受 HTML", "请填写普通文字，不要包含网页标签"],
  ["候选人可见文字不得包含直接联系方式", "展示资料中不能填写联系方式"],
  ["候选人可见文字不得包含社交账号", "展示资料中不能填写社交账号"],
  ["候选人可见文字不得包含 URL", "展示资料中不能填写网址"],
  ["候选人可见文字不得包含精确地址", "展示资料中不能填写具体地址"],

  // Current location, inbound visibility and recommendation scope remain distinct.
  ["当前所在地无法生成候选人可见名称", "暂时无法显示所在地名称，请检查地点设置"],
  ["所在地版本已变化", "所在地已更新，请刷新后再继续"],
  ["地点开放边界格式不正确", "地点范围格式有误，请重新选择"],
  ["地点开放边界无效", "目前不能使用这个地点范围，请重新选择"],
  ["地点待确认时，请主动选择合法的更大开放范围", "所在地尚未确认，暂时不能使用同城范围。可以等待确认，或自行选择更大的范围"],
  ["地点待确认时不能选择同城开放范围", "所在地尚未确认，暂时不能选择同城范围"],
  ["所在地确认后才能使用同城开放范围", "所在地确认后才能选择同城范围"],
  ["自选地点范围至少需要一个国家、地区或城市", "请至少选择一个国家、地区或城市"],
  ["当前开放方式不接受自选地点", "只有选择“自选地点”后，才能添加国家、地区或城市"],
  ["永久结束参与后不能修改 Result Location Scope", "已永久结束匹配，无法再修改推荐人选的地点范围"],
  ["Result Location Scope 格式不正确", "推荐人选的地点范围格式有误，请重新选择"],
  ["Result Location Scope 版本已变化", "推荐人选的地点范围已更新，请刷新后再修改"],
  ["Result Location Scope 包含未知城市", "推荐范围中有无法识别的城市，请重新选择"],

  // Encounter, contact sharing and optional pre-meeting answers.
  ["对这位参与者的一次 Retry 已经使用或正在处理", "对这位参与者重新考虑的机会已经用过，或正在处理中"],
  ["这位参与者当前不在你的 History 中", "这位参与者目前不在“曾经遇见”中，无法重新考虑"],
  ["Connection 不存在或不属于当前账户", "这段连接不存在，或当前账户无权查看"],
  ["联系方式不符合 Contact Sharing v1 合同", "请检查联系方式类型，并填写 1–200 个字符的纯文本内容"],
  ["Other 联系方式需要 1–40 个字符的自定义标签", "选择“其他”时，请填写 1–40 个字符的联系方式名称"],
  ["预设联系方式不能设置自定义标签", "只有选择“其他”时，才能自定义联系方式名称"],
  ["Contact Escrow 密钥不可用或密文无法验证", "暂时无法安全读取这条联系方式，请稍后重试"],
  ["Contact Escrow 密钥不可用", "联系方式服务暂时不可用，请稍后重试"],
  ["联系方式版本已变化", "联系方式已更新，请刷新后再修改"],
  ["当前不能读取对方的联系方式", "目前无法查看对方的联系方式"],
  ["Before we meet 请求格式不正确", "见面前补充内容的请求格式有误，请刷新后重试"],
  ["Before we meet 内容不符合七题 v1 合同", "请确认填写的是当前问题，每题回答最多 1000 个字符"],
  ["Before we meet 版本已变化", "见面前补充的回答已更新，请刷新后再修改"],
  ["回应必须是 accepted 或 declined", "请选择是否接受这次认识邀请"],

  // Operator messages keep their specific cause and action boundary.
  ["Operator Access 尚未配置", "管理权限尚未配置"],
  ["管理操作缺少确认标记", "请先确认这项管理操作"],
  ["创建请求缺少有效的幂等标识", "无法识别这次创建操作，请刷新后重试"],
  ["评审请求缺少有效的幂等标识", "无法识别这次评审操作，请刷新后重试"],
  ["评审幂等标识已用于另一项操作", "这次评审请求与之前的操作内容不同，请刷新状态后再操作"],
  ["评审状态不属于原型允许的状态", "请选择当前提供的评审状态"],
  ["没有找到这条 Pair Evaluation", "没有找到这条配对评估"],
  ["参与者当前不满足手动评估的运营资格", "参与者目前不符合手动评估的条件"],
  ["双方当前不满足相互开放边界，无法创建 Pair Evaluation", "双方目前不符合彼此的匹配条件，无法开始配对评估"],
  ["锁定问卷无法形成受信任的 Pair Evaluation 输入", "无法验证已锁定问卷是否可用于配对评估，请检查问卷记录"],
]);

const KNOWN_API_ERROR_COPY = new Set([...API_ERROR_COPY.keys(), ...API_ERROR_COPY.values()]);

export function hasApiErrorCopy(message: string): boolean {
  return KNOWN_API_ERROR_COPY.has(message);
}

export function apiErrorCopy(message: string): string {
  return API_ERROR_COPY.get(message) ?? message;
}
